import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './common/auth.guard';
import { BusinessEntityComponent } from './web/leftnav/AdminPanel/TradingCommunity/BusinessEntities/business-entity/business-entity.component';
import { BusinessEntityFarmProviderComponent } from './web/leftnav/AdminPanel/TradingCommunity/BusinessEntities/business-entity-farm-provider/business-entity-farm-provider.component';
import { BusinessEntityFarmsComponent } from './web/leftnav/AdminPanel/TradingCommunity/BusinessEntities/business-entity-farms/business-entity-farms.component';
import { BusinessEntityFarmSiteComponent } from './web/leftnav/AdminPanel/TradingCommunity/BusinessEntities/business-entity-farm-site/business-entity-farm-site.component';
import { AddFarmComponent } from './web/leftnav/AdminPanel/TradingCommunity/BusinessEntities/add-farm/add-farm.component';
import { PersonsListComponent } from './web/leftnav/AdminPanel/TradingCommunity/People/persons-list.component';
import { BusinessFarmfpFarmFarmsiteComponent } from './web/leftnav/AdminPanel/TradingCommunity/BusinessEntities/business-farmfp-farm-farmsite/business-farmfp-farm-farmsite.component';
import { BlubayDashboardComponent } from './web/leftnav/blubay-dashboard/blubay-dashboard.component';
import { CultureSummaryReportComponent } from './web/leftnav/Reports/Farm/CultureSummary/culture-summary-report.component';
import { LoginComponent } from './web/login/login.component';
import { PrivacyPolicyComponent } from './web/privacy-policy/privacy-policy.component';
import { ImagesDetailsComponent } from './web/leftnav/blubay-dashboard/images-details/images-details.component';
import { TermsofuseComponent } from './web/termsofuse/termsofuse.component';
import { PondsSummaryReportsComponent } from './web/leftnav/Reports/Farm/PondSummary/ponds-summary-reports.component';
import { AclSyncComponent } from './web/leftnav/AdminPanel/UserAccess/Sync/acl-sync.component';
import { SpeciesTypeComponent } from './web/leftnav/AdminPanel/Pond/SpeciesType/species-type.component';
import { CultureCategoryComponent } from './web/leftnav/AdminPanel/Pond/CultureCategories/culture-category.component';
import { SoilTypeComponent } from './web/leftnav/AdminPanel/Pond/SoilType/soil-type.component';
import { BarCodeComponent } from './web/leftnav/AdminPanel/AddBarcode/bar-code.component';
import { WaterQualityHistoryComponent } from './web/leftnav/History/WaterQuality/water-quality-history.component';
import { TotalAreaListComponent } from './web/leftnav/blubay-dashboard/total-area-list/total-area-list.component';
import { TotalPondsListComponent } from './web/leftnav/blubay-dashboard/total-ponds-list/total-ponds-list.component';
import { TotalStockingListComponent } from './web/leftnav/blubay-dashboard/total-stocking-list/total-stocking-list.component';
import { WaterTypeComponent } from './web/leftnav/AdminPanel/Pond/WaterType/water-type.component';
import { UomComponent } from './web/leftnav/AdminPanel/MaterialManagement/UOM/uom.component';
import { ItemTypesComponent } from './web/leftnav/AdminPanel/MaterialManagement/ItemType/item-types.component';
import { TransactionTypeComponent } from './web/leftnav/AdminPanel/MaterialManagement/TransactionType/transaction-type.component';
import { FeedComponent } from './web/leftnav/Metrics/Farm/Feed/feed.component';
import { StockingDensityComponent } from './web/leftnav/Metrics/Farm/StockingDensity/stocking-density.component';
import { PondComponent } from './web/leftnav/Metrics/Farm/Pond/pond.component';
import { WaterQualityComponent } from './web/leftnav/Metrics/Farm/WaterQuality/water-quality.component';
import { GrowthComponent } from './web/leftnav/Metrics/Farm/Sampling/growth.component';
import { HarvestComponent } from './web/leftnav/Metrics/Farm/Harvest/harvest.component';
import { MaterialMovementRegisterComponent } from './web/leftnav/Reports/Farm/MaterialMovementRegister/material-movement-register.component';
import { TransactionRegisterComponent } from './web/leftnav/Reports/Farm/TransactionsRegister/transaction-register.component';
import { RoutesComponent } from './web/leftnav/AdminPanel/UserAccess/Routes/routes.component';
import { FeatureComponent } from './web/leftnav/AdminPanel/UserAccess/Feature/feature.component';
import { ScreenComponent } from './web/leftnav/AdminPanel/UserAccess/Screen/screen.component';
import { FarmSpendAnalyzerComponent } from './web/leftnav/MaterialManagement/FarmSpendAnalysis/farm-spend-analyzer.component';
import { SMEDashboardComponent } from '../app/web/sme-dashboard/sme-dashboard.component';
import { VendorMasterComponent } from './web/leftnav/AdminPanel/MaterialManagement/VendorMaster/vendor-master.component';
import { BatchTransactionComponent } from './web/leftnav/MaterialManagement/BatchTransactions/batch-transaction/batch-transaction.component';
import { BatchEntryDashboardComponent } from './web/leftnav/MaterialManagement/BatchTransactions/batch-entry-dashboard/batch-entry-dashboard.component';
import { MultiLinePurchaseComponent } from './web/leftnav/MaterialManagement/BatchTransactions/MultiLinePurchase/multi-line-purchase.component';
import { PondTracebilityComponent } from './web/leftnav/Reports/Farm/TraceabilityReport/pond-tracebility.component';
import { DaySummaryComponent } from './web/leftnav/Reports/Farm/DaySummary/day-summary.component';
import { ProjectedFeedGraphComponent } from './web/leftnav/Charts/Trend Analysis/ActualVsProjected/projected-feed-graph/projected-feed-graph.component';
import { TankshiftComponent } from './web/leftnav/AdminPanel/tankshift/tankshift.component';
import { PaymentTransactionComponent } from './web/leftnav/MaterialManagement/payment-transaction/payment-transaction.component';
import { MaterialTransactionComponent } from './web/leftnav/MaterialManagement/material-transaction/material-transaction.component';
import { PaymentTransactionRegisterComponent } from './web/leftnav/Reports/Farm/payment-transaction-register/payment-transaction-register.component';
import { AnalyticsComponent } from './web/leftnav/Charts/analytics/analytics.component';
import { BusinessCategoryComponent } from './web/leftnav/AdminPanel/UserAccess/business-category/business-category.component';
import { PersonRoleComponent } from './web/leftnav/AdminPanel/UserAccess/person-role/person-role.component';
import { BusinessTypeComponent } from './web/leftnav/AdminPanel/UserAccess/business-type/business-type.component';
import { ProductsComponent } from './web/leftnav/AdminPanel/MaterialManagement/products/products.component';
import { ShapesComponent } from './web/leftnav/AdminPanel/MaterialManagement/shapes/shapes.component';
import { ActivityTrackerComponent } from './web/leftnav/Reports/Staff/activity-tracker/activity-tracker.component';
import { PriceTickerUploadComponent } from './web/leftnav/price-ticker-upload/price-ticker-upload.component';
import { OrdersComponent } from './web/leftnav/AdminPanel/Orders/orders.component';
import { HomeComponent } from './home/home.component';
import { ForgotPasswordStep1Component } from './web/forgot-password-step1/forgot-password-step1.component';
import { ForgotPasswordStep2Component } from './web/forgot-password-step2/forgot-password-step2.component';
import { ResetpasswordComponent } from './web/resetpassword/resetpassword.component';
import { WeeklyGrowthReportComponent } from './web/leftnav/Reports/Farm/weeklyGrowth/weekly-growth-report/weekly-growth-report.component';
import { QuickRegistrationComponent } from './web/leftnav/AdminPanel/TradingCommunity/quick-registration/quick-registration.component';
import { CultureEstimatorComponent } from './web/leftnav/Reports/Farm/cultureEstimator/culture-estimator/culture-estimator.component';
import { AccountClosureComponent } from './web/leftnav/AdminPanel/TradingCommunity/Account-closure/account-closure/account-closure.component';
import { AccountClosureDialogPopupsComponent } from './web/leftnav/AdminPanel/AccountClosureDialogPopups/account-closure-dialog-popups/account-closure-dialog-popups.component';
import { ActivityTrackerCopyComponent } from './web/leftnav/Reports/Staff/activity-tracker-copy/activity-tracker-copy.component';
import { DashboardCopyComponent } from './web/leftnav/providerTechnican/dashboard-copy/dashboard-copy.component';
import { SubscriptionPlansComponent } from './subscription-plans/subscription-plans.component';
import { DashboardComponent } from './web/admin-dashboard/dashboard.component';
import { ActivitiesListComponent } from './web/leftnav/AdminPanel/MaterialManagement/activities-list/activities-list.component';
import { BroodBreedersComponent } from './web/leftnav/AdminPanel/MaterialManagement/brood-breeders/brood-breeders.component';
import { BroodLinesComponent } from './web/leftnav/AdminPanel/MaterialManagement/brood-lines/brood-lines.component';
import { ObservationTypesComponent } from './web/leftnav/AdminPanel/MaterialManagement/observation-types/observation-types.component';
import { PondTypesComponent } from './web/leftnav/AdminPanel/MaterialManagement/pond-types/pond-types.component';
import { PondUsagesComponent } from './web/leftnav/AdminPanel/MaterialManagement/pond-usages/pond-usages.component';
import { TreatmentTypesComponent } from './web/leftnav/AdminPanel/MaterialManagement/treatment-types/treatment-types.component';
import { SensorComponent } from './web/leftnav/AdminPanel/Hardware/Sensor/sensor.component';
import { SensorTypeComponent } from './web/leftnav/AdminPanel/Hardware/SensorType/sensor-type.component';
import { DeviceModelComponent } from './web/leftnav/AdminPanel/Hardware/DeviceModel/device-model.component';
import { QPTypeComponent } from './web/leftnav/AdminPanel/Test Configurations/QualityParametersType/qp-type.component';
import { QpRangesComponent } from './web/leftnav/AdminPanel/Test Configurations/QPRanges/qp-ranges.component';
import { QueryParamsComponent } from './web/leftnav/AdminPanel/Test Configurations/QualityParameters/query-params.component';
import { TestCategoryComponent } from './web/leftnav/AdminPanel/Test Configurations/TestCategories/test-category.component';
import {SubscriptionsComponent} from "./web/leftnav/Reports/subscriptions/subscriptions.component";
import { BluEyeComponent } from './web/bluEye/blu-eye.component';
import { MarketConnectComponent } from './web/leftnav/market-connect/market-connect.component';

/**
 * @constant routes
 * @type {Routes}
 * @description
 * Defines the primary routing configuration for the AquaCloud application. This array maps URL paths
 * to their corresponding Angular components, enabling navigation throughout the application.
 *
 * **Key Features:**
 * - **Route Protection**: Utilizes the `AuthGuard` to protect routes that require user authentication.
 * - **Lazy Loading (Future)**: Structured to support lazy loading of feature modules to improve initial load times.
 * - **Role-Based Access (Implicit)**: The structure allows for different views based on user roles, managed by the components themselves or future role-based guards.
 * - **Hierarchical Routing**: Uses a nested `children` array under the `/home` path to create a consistent layout for authenticated users, with a shared `HomeComponent` containing the main navigation.
 *
 * **Route Structure:**
 * 1. **Public Routes**: Accessible to all users without authentication (e.g., `/login`, `/forgotpasswordstep1`).
 * 2. **Authenticated Routes**: Nested under `/home` and protected by `AuthGuard`. These routes represent the core application functionality.
 * 3. **Specialized Routes**: Top-level routes for specific purposes, like `smelandingpage`.
 * 4. **Wildcard Route**: A catch-all route (`**`) that redirects any unmatched URL to the login page, preventing 404 errors.
 *
 * @guard AuthGuard - Protects routes by verifying that a user session exists in `localStorage`. If the check fails, it redirects the user to the `/login` page.
 *
 * @example
 * // A typical protected route definition
 * {
 *   path: 'home',
 *   component: HomeComponent,
 *   canActivate: [AuthGuard], // This route and its children are protected
 *   children: [
 *     { path: 'dashboard', component: BlubayDashboardComponent, canActivate: [AuthGuard] }
 *   ]
 * }
 */
const routes: Routes = [
  // ==========================================================================
  // Public & Redirection Routes
  // ==========================================================================
  { path: '', pathMatch: 'full', redirectTo: '/login' },
  { path: '#/', pathMatch: 'full', redirectTo: '/login' },
  { path: 'login', component: LoginComponent },
  { path: 'forgotpasswordstep1', component: ForgotPasswordStep1Component },
  { path: 'forgotpasswordstep2/:id', component: ForgotPasswordStep2Component },
  { path: 'resetpasswordstep1', component: ResetpasswordComponent },

  // ==========================================================================
  // Main Authenticated Application Layout
  // All child routes are protected by the parent's AuthGuard.
  // ==========================================================================
  {
    path: 'home', component: HomeComponent, canActivate: [AuthGuard],
    children: [
      { path: '', component: BlubayDashboardComponent, canActivate: [AuthGuard] },
      { path: 'privacypolicy', component: PrivacyPolicyComponent },
      { path: 'termsofduse', component: TermsofuseComponent },
      { path: 'dashboard', component: DashboardCopyComponent, canActivate: [AuthGuard] },
      { path: 'blubayuserlogin/:id', component: LoginComponent },

      // --------------------------------------------------------------------------
      // Admin Panel: User Access & Security
      // --------------------------------------------------------------------------
      { path: 'aclsync', component: AclSyncComponent, canActivate: [AuthGuard] },
      { path: 'routes', component: RoutesComponent, canActivate: [AuthGuard] },
      { path: 'feature', component: FeatureComponent, canActivate: [AuthGuard] },
      { path: 'screen', component: ScreenComponent, canActivate: [AuthGuard] },
      { path: 'projectedfeedgraph', component: ProjectedFeedGraphComponent, canActivate: [AuthGuard] },
      /*Masters tables of MM path*/
      { path: 'transactiontype', component: TransactionTypeComponent, canActivate: [AuthGuard] },
      { path: 'activitieslist', component: ActivitiesListComponent, canActivate: [AuthGuard] },
      { path: 'broodbreederslist', component: BroodBreedersComponent, canActivate: [AuthGuard] },
      { path: 'broodlineslist', component: BroodLinesComponent, canActivate: [AuthGuard] },
      { path: 'observationtypeslist', component: ObservationTypesComponent, canActivate: [AuthGuard] },
      { path: 'pondtypeslist', component: PondTypesComponent, canActivate: [AuthGuard] },
      { path: 'pondusageslist', component: PondUsagesComponent, canActivate: [AuthGuard] },
      { path: 'treatmenttypeslist', component: TreatmentTypesComponent, canActivate: [AuthGuard] },

      // --------------------------------------------------------------------------
      // Admin Panel: Material Management Masters
      // --------------------------------------------------------------------------
      { path: 'uom', component: UomComponent, canActivate: [AuthGuard] },
      { path: 'itemtype', component: ItemTypesComponent, canActivate: [AuthGuard] },
      { path: 'products', component: ProductsComponent, canActivate: [AuthGuard] },
      { path: 'orders', component: OrdersComponent, canActivate: [AuthGuard] },
      { path: 'vendormaster', component: VendorMasterComponent, canActivate: [AuthGuard] },
      { path: 'devicemodel', component: DeviceModelComponent, canActivate: [AuthGuard] },
      { path: 'sensor', component: SensorComponent, canActivate: [AuthGuard] },
      { path: 'sensortype', component: SensorTypeComponent, canActivate: [AuthGuard] },
      { path: 'qualityparamtype', component: QPTypeComponent, canActivate: [AuthGuard] },
      { path: 'testcategory', component: TestCategoryComponent, canActivate: [AuthGuard] },
      { path: 'qualityparameter', component: QueryParamsComponent, canActivate: [AuthGuard] },
      { path: 'qprange', component: QpRangesComponent, canActivate: [AuthGuard] },
      /*end Masters tables MM path*/

      // --------------------------------------------------------------------------
      // Dashboard & Details
      // --------------------------------------------------------------------------
      { path: 'imagesDetails', component: ImagesDetailsComponent, canActivate: [AuthGuard] },
      { path: 'totalpondslist', component: TotalPondsListComponent, canActivate: [AuthGuard] },
      { path: 'totalstockinglist', component: TotalStockingListComponent, canActivate: [AuthGuard] },
      { path: 'totalarealist', component: TotalAreaListComponent, canActivate: [AuthGuard] },
      { path: 'historywaterquality', component: WaterQualityHistoryComponent, canActivate: [AuthGuard] },
      { path: 'culturesummaryreport', component: CultureSummaryReportComponent, canActivate: [AuthGuard] },

      // --------------------------------------------------------------------------
      // Reports
      // --------------------------------------------------------------------------
      { path: 'pondsummaryreport', component: PondsSummaryReportsComponent, canActivate: [AuthGuard] },
      { path: 'traceabilityreport', component: PondTracebilityComponent, canActivate: [AuthGuard] },
      { path: 'daysummary', component: DaySummaryComponent, canActivate: [AuthGuard] },
      { path: 'weeklygrowth', component: WeeklyGrowthReportComponent, canActivate: [AuthGuard] },
      { path: 'tankshift', component: TankshiftComponent, canActivate: [AuthGuard] },
      { path: 'activitytracker', component: ActivityTrackerComponent, canActivate: [AuthGuard] },
      { path: 'visits', component: ActivityTrackerCopyComponent, canActivate: [AuthGuard] },

      // --------------------------------------------------------------------------
      // Material Management & Transactions
      // --------------------------------------------------------------------------
      { path: 'farmspendanalysis', component: FarmSpendAnalyzerComponent, canActivate: [AuthGuard] },
      { path: 'materialtransaction', component: MaterialTransactionComponent, canActivate: [AuthGuard] },
      { path: 'batchtransaction', component: BatchTransactionComponent, canActivate: [AuthGuard] },
      { path: 'mmregister', component: MaterialMovementRegisterComponent, canActivate: [AuthGuard] },
      { path: 'transactionregister', component: TransactionRegisterComponent, canActivate: [AuthGuard] },
      /*{path: 'paymenttransaction', component: PaymenttransactionsComponent, canActivate: [AuthGuard]},*/
      { path: 'paymenttransaction', component: PaymentTransactionComponent, canActivate: [AuthGuard] },
      /*{path: 'paymenttransactionregister', component: PaymentTransactionRegisterComponent, canActivate: [AuthGuard]},*/
      { path: 'paymentregister', component: PaymentTransactionRegisterComponent, canActivate: [AuthGuard] },
      { path: 'cultureEstimator', component: CultureEstimatorComponent, canActivate: [AuthGuard] },
      { path: 'account-closure/businessID/:id', component: AccountClosureComponent, canActivate: [AuthGuard] },
      { path: 'account-closure', component: AccountClosureDialogPopupsComponent, canActivate: [AuthGuard] },

      // --------------------------------------------------------------------------
      // Admin Panel: Configuration & Masters
      // --------------------------------------------------------------------------
      { path: 'addbarcode', component: BarCodeComponent, canActivate: [AuthGuard] },
      { path: 'culturecategory', component: CultureCategoryComponent, canActivate: [AuthGuard] },
      { path: 'watertype', component: WaterTypeComponent, canActivate: [AuthGuard] },
      { path: 'soiltype', component: SoilTypeComponent, canActivate: [AuthGuard] },
      { path: 'speciestype', component: SpeciesTypeComponent, canActivate: [AuthGuard] },

      // -------------------------------------------------------------------------
      // Farm Metrics
      // --------------------------------------------------------------------------
      { path: 'farmpond', component: PondComponent, canActivate: [AuthGuard] },
      { path: 'farmstockingdensity', component: StockingDensityComponent, canActivate: [AuthGuard] },
      { path: 'farmfeed', component: FeedComponent, canActivate: [AuthGuard] },
      { path: 'farmharvest', component: HarvestComponent, canActivate: [AuthGuard] },
      { path: 'farmsampling', component: GrowthComponent, canActivate: [AuthGuard] },
      { path: 'farmwaterquality', component: WaterQualityComponent, canActivate: [AuthGuard] },
      { path: 'Quick-Registartion', component: QuickRegistrationComponent, canActivate: [AuthGuard] },

      // --------------------------------------------------------------------------
      // Trading Community & Business Entity Management
      // --------------------------------------------------------------------------
      { path: 'Business-Entity/:isAdmin', component: BusinessEntityComponent, canActivate: [AuthGuard] },
      { path: 'BusinessEntityFarmsProvider/:businessID/:isAdmin', component: BusinessEntityFarmProviderComponent, canActivate: [AuthGuard] },
      { path: 'BusinessEntityFarms/:businessID/:isAdmin', component: BusinessEntityFarmsComponent, canActivate: [AuthGuard] },
      {
        path: 'BusinessFP-Farm-Farmsite/:farmProviderid/:farmId/:isFarmsite',
        component: BusinessFarmfpFarmFarmsiteComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'BusinessEntityFarmSite/:id/:farmId/:FarmProviderId/:isAdmin',
        component: BusinessEntityFarmSiteComponent,
        canActivate: [AuthGuard]
      },
      { path: 'BusinessFarmSite/:id', component: BusinessEntityFarmSiteComponent, canActivate: [AuthGuard] },
      { path: 'Add-Farm/:id', component: AddFarmComponent, canActivate: [AuthGuard] },
      { path: 'Persons-List/:isAdmin', component: PersonsListComponent, canActivate: [AuthGuard] },

      // --------------------------------------------------------------------------
      // Miscellaneous & Other Features
      // --------------------------------------------------------------------------
      {
        path: 'batchentrydashboard', component: BatchEntryDashboardComponent, canActivate: [AuthGuard]
      },
      {
        path: 'analytics', component: AnalyticsComponent, canActivate: [AuthGuard]
      },
      { path: 'multilinepurchase', component: MultiLinePurchaseComponent, canActivate: [AuthGuard] },
      { path: 'businesscategory', component: BusinessCategoryComponent, canActivate: [AuthGuard] },
      { path: 'businesstype', component: BusinessTypeComponent, canActivate: [AuthGuard] },
      { path: 'personrole', component: PersonRoleComponent, canActivate: [AuthGuard] },
      { path: 'shapes', component: ShapesComponent, canActivate: [AuthGuard] },
      { path: 'pricetickerupload', component: PriceTickerUploadComponent, canActivate: [AuthGuard] },
      { path: 'subscriptionPlans', component: SubscriptionPlansComponent, canActivate: [AuthGuard]},
      { path: 'subscriptions', component: SubscriptionsComponent, canActivate: [AuthGuard]},
      { path: 'bluEye', component: BluEyeComponent, canActivate: [AuthGuard]},
      { path: 'marketconnect', component: MarketConnectComponent, canActivate: [AuthGuard] },

      // Wildcard route for any unknown paths under '/home'
      { path: '**', component: LoginComponent },
    ],
  },
  // ==========================================================================
  // Standalone Feature Routes
  // ==========================================================================
  { path: 'smelandingpage', component: SMEDashboardComponent, canActivate: [AuthGuard] },
];

/**
 * @module AppRoutingModule
 * @description
 * The main routing module for the application.
 *
 * This module configures the Angular `RouterModule` with all the application's routes.
 * It uses the `forRoot` method because it is the root routing module.
 *
 * **Configuration:**
 * - `useHash: true`: Enables the hash-based routing strategy (`/#/path`). This is often used for compatibility with older browsers or specific server configurations.
 * - `scrollPositionRestoration: 'top'`: Ensures that the user is scrolled to the top of the page upon every navigation.
 */
@NgModule({
  // imports: [RouterModule.forRoot(routes)],
  imports: [RouterModule.forRoot(routes, { useHash: true, scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
